import React from 'react';
import { useAppSelector } from '../../../state/hooks';
import { Selection4OpinionStyles } from './styles';
import getTranslationsByLangOrEng from '../../../utils/getTranslationsByLangOrLang';
import selection1 from '../../../assets/images/4opinion/poll-1.png';
import selection2 from '../../../assets/images/4opinion/poll-2.png';
import selection3 from '../../../assets/images/4opinion/poll-3.png';
import selection4 from '../../../assets/images/4opinion/poll-4.png';
import selection5 from '../../../assets/images/4opinion/poll-5.png';
import selection6 from '../../../assets/images/4opinion/poll-6.png';

export const Selection4Opinion = () => {
  const { interfaceLanguage } = useAppSelector((state) => state.languages);
  return (
    <Selection4OpinionStyles>
      <div className="container">
        <h2>{getTranslationsByLangOrEng(interfaceLanguage, 'four_opinion_16')}</h2>
        <div className="cards">
          <div className="cards-item">
            <img src={selection1} alt="" />
            <div className="cards-text">
              <h6>{getTranslationsByLangOrEng(interfaceLanguage, 'four_opinion_37')}</h6>
              <p>{getTranslationsByLangOrEng(interfaceLanguage, 'four_opinion_38')}</p>
            </div>
          </div>
          <div className="cards-item">
            <img src={selection2} alt="" />
            <div className="cards-text">
              <h6>{getTranslationsByLangOrEng(interfaceLanguage, 'four_opinion_39')}</h6>
              <p>{getTranslationsByLangOrEng(interfaceLanguage, 'four_opinion_40')}</p>
            </div>
          </div>
          <div className="cards-item">
            <img src={selection3} alt="" />
            <div className="cards-text">
              <h6>{getTranslationsByLangOrEng(interfaceLanguage, 'four_opinion_41')}</h6>
              <p>{getTranslationsByLangOrEng(interfaceLanguage, 'four_opinion_42')}</p>
            </div>
          </div>
          <div className="cards-item">
            <img src={selection4} alt="" />
            <div className="cards-text">
              <h6>{getTranslationsByLangOrEng(interfaceLanguage, 'four_opinion_43')}</h6>
              <p>{getTranslationsByLangOrEng(interfaceLanguage, 'four_opinion_44')}</p>
            </div>
          </div>
          <div className="cards-item">
            <img src={selection5} alt="" />
            <div className="cards-text">
              <h6>{getTranslationsByLangOrEng(interfaceLanguage, 'four_opinion_45')}</h6>
              <p>{getTranslationsByLangOrEng(interfaceLanguage, 'four_opinion_46')}</p>
            </div>
          </div>
          <div className="cards-item">
            <img src={selection6} alt="" />
            <div className="cards-text">
              <h6>{getTranslationsByLangOrEng(interfaceLanguage, 'four_opinion_47')}</h6>
              <p>{getTranslationsByLangOrEng(interfaceLanguage, 'four_opinion_48')}</p>
            </div>
          </div>
        </div>
      </div>
    </Selection4OpinionStyles>
  );
};
